/** Common async pattern utils */

import { useHekateEventBus } from '~/composables/useHekateEventBus';

/** Common async pattern utils */
const RsvpUtil = {
  /**
   * Resolve when `predicate()` returns true or timed out.
   *
   * predicate - function to test if DOM is ready
   * timeout - timeout in milliseconds
   * minWait - how long to wait before starting to poll
   * return true if predicate is true else return false
   */
  async fluentWait({
    predicate,
    timeout,
    minWait,
  }: {
    predicate: () => boolean;
    timeout: number;
    minWait: number;
  }): Promise<boolean> {
    await RsvpUtil.wait(minWait);

    // don't even start polling if it's already true
    if (predicate()) {
      return true;
    }

    const tooOld = Date.now() + timeout;
    let interval: number;
    window.setTimeout(() => {
      window.clearInterval(interval);
    }, timeout + 250);
    return new Promise((res) => {
      interval = window.setInterval(() => {
        if (Date.now() > tooOld) {
          window.clearInterval(interval);
          res(false);
        }
        if (predicate()) {
          window.clearInterval(interval);
          res(true);
        }
      }, 250);
    });
  },

  /** Wait timeoutMilliseconds before resolving */
  wait(timeoutMilliseconds: number): Promise<void> {
    return new Promise((res) => {
      setTimeout(() => res(), timeoutMilliseconds);
    });
  },

  /** Run this cb immediately, and then again on form-ready event */
  async runImmediatelyAndOnFormReady({ cb }: { cb: VoidFunction }) {
    cb();
    const { addEventListener } = useHekateEventBus();
    addEventListener('form-ready', () => cb());
  },
};

export default RsvpUtil;
